module.exports = __webpack_public_path__ + "images/icons_v2/values-debate-2b066e3a.svg";